import { useEffect, useState, useContext } from 'react';

import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';
import Utils from '@lcsc-ui/utils/Utils';
import { styled } from 'styled-components';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import wwwapi from '@/asyncApi/home';
import BottomAdContext from '@/context/BottomAdContext';

const CustomSwiperStyle = styled.div`
  /* 当鼠标悬停在Swiper容器上时显示导航箭头 */
  .swiper-pagination {
    bottom: 15px;
    .swiper-pagination-bullet {
      width: 10px;
      height: 10px;
      background: #ffffff;
    }
  }
`;

const pagination = {
  clickable: true,
};

const IndexBannerArea = ({ logined }) => {
  const [bannerData, setBannerData] = useState({
    banner1: null,
    banner2: null,
    carouselBanner: [],
  });
  const { isLgScreen } = useContext(BottomAdContext);
  const { banner1, banner2, carouselBanner } = bannerData;

  async function fecthData() {
    const { result } = await sendAxios({
      method: 'get',
      url: wwwapi.indexCarouselBanner,
      baseURL: Domains.lcscOpUrl,
    });
    setBannerData({
      banner1: result.banner1 || null,
      banner2: result.banner2 || null,
      carouselBanner: result.carouselBanner || [],
    });
  }

  useEffect(() => {
    try {
      fecthData();
    } catch (error) {
      //...
    }
  }, [logined]);

  function handleCarouselBannerClick({ realIndex }) {
    buriedPoint({
      ty: 'click',
      cp: 'index',
      op: 'banner_ad',
      pf: 'pc',
      data: { hf: carouselBanner[realIndex]?.targetLink, idx: realIndex },
    });
  }
  function handleSmallBannerClick(op, hf) {
    buriedPoint({
      ty: 'click',
      cp: 'index',
      op,
      pf: 'pc',
      data: { hf },
    });

    if (op === 'BANNER_AD_small_down' && hf && hf.includes('/www.jlc.com/newOrder')) {
      // PCB/SMT智造
      buriedPoint({
        ty: 'click',
        cp: 'index_marketing',
        op: 'go_marketing',
        pf: 'pc',
      });
    }
  }

  return (
    <CustomSwiperStyle className="_lg:w-[996px] _lg:flex _lg:items-center w-[634px]">
      {Utils.isEmpty(carouselBanner) ? (
        <div className="_lg:w-[685px] w-[634px] _lg:h-[520px] h-[353px] rounded-[10px] bg-[#f5f5f5]"></div>
      ) : (
        <Swiper
          wrapperTag="ul"
          tag="div"
          className="_lg:w-[685px] _lg:h-[520px] relative custom-group rounded-[10px]"
          data-spm="lb"
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          navigation={{
            nextEl: '#big-banner-custom-next-button',
            prevEl: '#big-banner-custom-prev-button',
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop
          pagination={pagination}
          onClick={handleCarouselBannerClick}
        >
          {carouselBanner.map((carousel, idx) => (
            <SwiperSlide key={idx} tag="li">
              <a
                href={carousel?.targetLink}
                target="_blank"
                className="w-full h-[353px] _lg:h-[520px] bg-slate-300 block"
                data-spm={idx + 1}
              >
                <img
                  className="w-full h-full rounded-[8px]"
                  src={isLgScreen ? carousel.advertisingUrl : carousel.imageUrl}
                />
              </a>
            </SwiperSlide>
          ))}

          {/* 自定义导航按钮 */}
          <div
            id="big-banner-custom-prev-button"
            className="absolute top-[50%] mt-[-25px] left-0 z-[1] hidden custom-group-hover-block"
          >
            <button
              className="w-[50px] h-[63px] bg-[url(//static.szlcsc.com/ecp/assets/web/page/www/index/images/index-banner-left-hover.svg)] hover:bg-[url(//static.szlcsc.com/ecp/assets/web/page/www/index/images/index-banner-left.svg)]"
              aria-label="轮播图上一张图片"
            ></button>
          </div>
          <div
            id="big-banner-custom-next-button"
            className="absolute top-[50%] mt-[-25px] right-0 z-[1] hidden custom-group-hover-block"
          >
            <button
              className="w-[50px] h-[63px] bg-[url(//static.szlcsc.com/ecp/assets/web/page/www/index/images/index-banner-right-hover.svg)] hover:bg-[url(//static.szlcsc.com/ecp/assets/web/page/www/index/images/index-banner-right.svg)]"
              aria-label="轮播图下一张图片"
            ></button>
          </div>
        </Swiper>
      )}
      <div
        className="flex items-center justify-between _lg:flex-col _lg:h-[520px] _lg:ml-[16px] _lg:mt-0 mt-[16px]"
        data-spm="xlb"
      >
        {/* 两个小广告 */}
        {Utils.isEmpty(banner1) ? (
          <div className="inline-block w-[309px] h-[152px] _lg:w-[295px] _lg:h-[252px] rounded-[10px] bg-[#f5f5f5]"></div>
        ) : (
          <a
            href={banner1?.targetLink}
            target="_blank"
            className={`inline-block w-[309px] h-[152px] _lg:w-[295px] _lg:h-[252px]`}
            data-spm="1"
            onClick={() => handleSmallBannerClick('BANNER_AD_small_up', banner1?.targetLink)}
          >
            <img
              src={isLgScreen ? banner1.advertisingUrl : banner1.imageUrl}
              className="w-full h-full rounded-[10px]"
            />
          </a>
        )}
        {Utils.isEmpty(banner2) ? (
          <div className="inline-block w-[309px] h-[152px] _lg:w-[295px] _lg:h-[252px] rounded-[10px] bg-[#f5f5f5]"></div>
        ) : (
          <a
            href={banner2?.targetLink}
            target="_blank"
            className={`inline-block w-[309px] h-[152px] _lg:w-[295px] _lg:h-[252px]`}
            onClick={() => handleSmallBannerClick('BANNER_AD_small_down', banner2?.targetLink)}
            data-spm="2"
          >
            <img
              src={isLgScreen ? banner2.advertisingUrl : banner2.imageUrl}
              className="w-full h-full rounded-[10px]"
            />
          </a>
        )}
      </div>
    </CustomSwiperStyle>
  );
};

export default IndexBannerArea;
